import React,{useState} from 'react'
import './Service.css'
import {SiAltiumdesigner} from 'react-icons/si'
import {FaDesktop} from 'react-icons/fa'
import {FaMobileAlt} from 'react-icons/fa'
import {FaBookOpen} from 'react-icons/fa'
import {AiFillCheckCircle} from 'react-icons/ai'
import {Swiper,SwiperSlide} from 'swiper/react'

import "swiper/css";
import "swiper/css/navigation";

import { Navigation } from 'swiper'

const Skill = () => {
  const [visibleD,setVisibleD]=useState(false)
  const [visibleW,setVisibleW]=useState(false)
  const [visibleM,setVisibleM]=useState(false)
  const [visibleP,setVisibleP]=useState(false)

  return (
    <section id='services'>
        <h5>ce que je peux faire pour vous</h5>
        <h2>Mes services</h2>

        <Swiper navigation={ true} modules={[Navigation]} className=' container services__container' slidesPerView={1} spaceBetween={150}loop={true} effect={'fade'}>
        
            

            <SwiperSlide className='service__container'   onMouseOver={() => setVisibleW(true)} onMouseLeave={() => setVisibleW(false)}>
            {!visibleW ? <div className='z'>
              <FaDesktop className='icon__service' />
              <h4 >Applications Web</h4>
              </div>
              : <div className='za'>
                <p><AiFillCheckCircle /> Frontend </p>
                <p><AiFillCheckCircle /> Backend</p>
                <h4><AiFillCheckCircle /> Deploiement </h4>
                <h4><AiFillCheckCircle /> Maintenance </h4>

              </div>}
            </SwiperSlide>
            <SwiperSlide className='service__container'   onMouseOver={() => setVisibleM(true)} onMouseLeave={() => setVisibleM(false)}>
            {!visibleM ? <div className='z'>
              <FaMobileAlt className='icon__service' />
              <h4 >Applications mobile</h4>
              </div>
              : <div className='za'>
                <p><AiFillCheckCircle /> Frontend </p>
                <p><AiFillCheckCircle /> Backend</p>
                <h4><AiFillCheckCircle /> Deploiement </h4>
                <h4><AiFillCheckCircle /> Maintenance </h4>
              </div>}
            </SwiperSlide>
            <SwiperSlide className='service__container'   onMouseOver={() => setVisibleD(true)} onMouseLeave={() => setVisibleD(false)}>
            {!visibleD ? <div className='z'>
              <SiAltiumdesigner className='icon__service' />
              <h4 >UI/UX design</h4>
              </div>
              : <div className='za'>
                 <h4><AiFillCheckCircle /> Responsive web design</h4>
                <h4><AiFillCheckCircle /> Landing page</h4>
                <h4><AiFillCheckCircle /> Dashboard</h4>
                <h4><AiFillCheckCircle /> Wireframe</h4>
              </div>}
            </SwiperSlide>
           

           
           
              
          
           
       
        </Swiper>
    </section>
  )
}

export default Skill